/**
 * @generated SignedSource<<4d7241f2c42047cc56dede618c447f79>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type searchGraphCustomerContact_AtlassianSearchPage$data = {
  readonly __typename: "SearchResultGraphDocument";
  readonly entity: {
    readonly accountName?: string | null | undefined;
    readonly contactUser?: {
      readonly thirdPartyUser: {
        readonly extendedProfile: {
          readonly jobTitle: string | null | undefined;
        } | null | undefined;
        readonly name: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly id: string;
  readonly lastModifiedDate: string | null | undefined;
  readonly url: string;
  readonly " $fragmentType": "searchGraphCustomerContact_AtlassianSearchPage";
};
export type searchGraphCustomerContact_AtlassianSearchPage$key = {
  readonly " $data"?: searchGraphCustomerContact_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchGraphCustomerContact_AtlassianSearchPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "searchGraphCustomerContact_AtlassianSearchPage",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "url"
    },
    {
      "kind": "ScalarField",
      "name": "lastModifiedDate"
    },
    {
      "kind": "LinkedField",
      "name": "entity",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "accountName"
            },
            {
              "concreteType": "ExternalUser",
              "kind": "LinkedField",
              "name": "contactUser",
              "plural": false,
              "selections": [
                {
                  "concreteType": "ThirdPartyUser",
                  "kind": "LinkedField",
                  "name": "thirdPartyUser",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "name"
                    },
                    {
                      "concreteType": "ThirdPartyUserExtendedProfile",
                      "kind": "LinkedField",
                      "name": "extendedProfile",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "jobTitle"
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ],
          "type": "ExternalCustomerContact"
        }
      ]
    }
  ],
  "type": "SearchResultGraphDocument"
};

(node as any).hash = "12a9377b2d2c510be0042ad9759961af";

export default node;
